export default "__VITE_ASSET__dPiCDciY__"